import * as React from 'react';
import { IInputTextProps, InputText } from '../../atoms/InputText';
import { Icon } from '../../atoms';
import { ViewOffIcon, ViewOnIcon } from '@align-cpf/uikit-icons';
import { createLocators } from '@u1/locators';
import useStyles from './InputPassword.styles';

export const inputPasswordLocators = createLocators({
  name: 'InputPassword',
  componentLocators: [
    'container',
    'iconShow',
    'iconHide',
    'input',
    'iconContainer',
  ],
});
const { locators } = inputPasswordLocators();

const InputPassword = React.forwardRef<HTMLInputElement, IInputTextProps>(
  (props, ref) => {
    const classes = useStyles();
    InputPassword.displayName = 'InputPassword';

    const [showPassword, setShowPassword] = React.useState(false);

    const togglePasswordView = () => {
      setShowPassword((show) => !show);
    };

    return (
      <div {...locators.container()} className={classes.root}>
        <InputText
          {...props}
          ref={ref}
          type={showPassword ? 'text' : 'password'}
          _UNSAFE_classname={classes.password}
        />
        <div
          {...locators.iconContainer()}
          className={classes.icon}
          onClick={togglePasswordView}
        >
          {showPassword ? (
            <Icon icon={ViewOnIcon} locatorsOverrides={locators.iconShow()} />
          ) : (
            <Icon icon={ViewOffIcon} locatorsOverrides={locators.iconHide()} />
          )}
        </div>
      </div>
    );
  },
);

export default InputPassword;
